/** Textes de la zone Déploiement (FR / EN / AR) : fusionnés dans les dictionnaires de `i18n/locales`. */

export const deploymentFr = {
  'deployment.pageTitle': 'Déploiement des agents',
  'deployment.pageDesc': 'Enrôlez vos machines en masse, générez les paquets et suivez les mises à jour.',
  'deployment.tabs': 'Sections du déploiement',
  'deployment.tab.tokens': 'Jetons d\'enrôlement',
  'deployment.tab.packages': 'Paquets et scripts',
  'deployment.tab.releases': 'Canaux et versions',
  'deployment.tab.progress': 'Progression',
  'deployment.cancel': 'Annuler',
  'deployment.close': 'Fermer',
  'deployment.copy': 'Copier',
  'deployment.copied': 'Copié dans le presse-papiers',
  'deployment.copyFailed': 'Copie impossible : sélectionnez le texte manuellement',
  'deployment.refresh': 'Actualiser',
  'deployment.status': 'Statut',
  'deployment.actions': 'Actions',
  'deployment.channel.stable': 'Stable',
  'deployment.channel.beta': 'Bêta',
  'deployment.channel.stable.desc': 'Versions validées, recommandées pour la production.',
  'deployment.channel.beta.desc': 'Nouveautés en avance de phase, pour un groupe pilote.',

  'deployment.token.title': 'Jetons d\'enrôlement',
  'deployment.token.desc': 'Un jeton permet à une machine de rejoindre l\'organisation sans intervention locale.',
  'deployment.token.new': 'Nouveau jeton',
  'deployment.token.newDesc': 'Choisissez le groupe cible, la durée de validité et le nombre d\'enrôlements autorisés.',
  'deployment.token.create': 'Créer le jeton',
  'deployment.token.createError': 'Création du jeton impossible',
  'deployment.token.label': 'Nom du jeton',
  'deployment.token.labelPlaceholder': 'Ex. Déploiement Intune — siège',
  'deployment.token.labelRequired': 'Le nom est obligatoire',
  'deployment.token.group': 'Groupe cible',
  'deployment.token.noGroup': 'Aucun groupe',
  'deployment.token.channel': 'Canal',
  'deployment.token.expiry': 'Validité',
  'deployment.token.days': '{count} jours',
  'deployment.token.maxUses': 'Usages maximum',
  'deployment.token.unlimited': 'Illimité',
  'deployment.token.maxUsesInvalid': 'Entrez un nombre entier supérieur à 0, ou laissez vide',
  'deployment.token.expiresAt': 'Expire le',
  'deployment.token.usage': 'Utilisation',
  'deployment.token.usageOf': 'Utilisation du jeton {label}',
  'deployment.token.usesUnlimited': '{count} usage(s), sans limite',
  'deployment.token.createdBy': 'par {name}',
  'deployment.token.empty': 'Aucun jeton d\'enrôlement',
  'deployment.token.emptyDesc': 'Créez un jeton pour enrôler vos premières machines.',
  'deployment.token.status.active': 'Actif',
  'deployment.token.status.revoked': 'Révoqué',
  'deployment.token.status.expired': 'Expiré',
  'deployment.token.status.exhausted': 'Épuisé',
  'deployment.token.copy': 'Copier le jeton {label}',
  'deployment.token.generate': 'Générer un paquet avec {label}',
  'deployment.token.revoke': 'Révoquer {label}',
  'deployment.token.revokeTitle': 'Révoquer ce jeton ?',
  'deployment.token.revokeDesc': 'Le jeton « {label} » ne pourra plus enrôler de machine. Les machines déjà enrôlées ne sont pas affectées.',
  'deployment.token.revokeConfirm': 'Révoquer',
  'deployment.token.revoked': 'Jeton révoqué',
  'deployment.token.revokeError': 'Révocation impossible',
  'deployment.token.createdTitle': 'Jeton créé',
  'deployment.token.createdDesc': 'Copiez le jeton maintenant.',
  'deployment.token.secretOnce': 'Ce secret n\'est affiché qu\'une seule fois. Conservez-le dans un coffre de secrets.',
  'deployment.token.goGenerate': 'Générer un paquet',

  'deployment.pkg.title': 'Générateur de paquets et de scripts',
  'deployment.pkg.desc': 'Le jeton choisi est intégré au script produit.',
  'deployment.pkg.token': 'Jeton d\'enrôlement',
  'deployment.pkg.version': 'Version de l\'agent',
  'deployment.pkg.secret': 'Secret du jeton',
  'deployment.pkg.secretHint': 'Le secret n\'est montré qu\'à la création. Collez-le ici pour l\'intégrer au script.',
  'deployment.pkg.secretInvalid': 'Format de secret invalide',
  'deployment.pkg.kind': 'Type de déploiement',
  'deployment.pkg.kind.msi': 'MSI (Windows)',
  'deployment.pkg.kind.msi.desc': 'Installation silencieuse via msiexec',
  'deployment.pkg.kind.pkg': 'PKG (macOS)',
  'deployment.pkg.kind.pkg.desc': 'Script d\'installation du paquet',
  'deployment.pkg.kind.intune': 'Script Intune',
  'deployment.pkg.kind.intune.desc': 'PowerShell idempotent pour Intune',
  'deployment.pkg.kind.jamf': 'Script Jamf',
  'deployment.pkg.kind.jamf.desc': 'Script Jamf Pro avec paramètres',
  'deployment.pkg.kind.shell': 'Commande shell',
  'deployment.pkg.kind.shell.desc': 'Une ligne pour Linux et macOS',
  'deployment.pkg.silent': 'Installation silencieuse',
  'deployment.pkg.silentDesc': 'Aucune fenêtre n\'est affichée à l\'utilisateur.',
  'deployment.pkg.preview': 'Aperçu du script',
  'deployment.pkg.previewDesc': 'Généré dans votre navigateur ; rien n\'est envoyé à Siraj.',
  'deployment.pkg.copyCommand': 'Copier la commande',
  'deployment.pkg.download': 'Télécharger le script',
  'deployment.pkg.downloaded': '{file} téléchargé',
  'deployment.pkg.placeholderWarning': 'Le secret du jeton est inconnu : le script contient un marqueur à remplacer avant utilisation.',
  'deployment.pkg.sensitive': 'Ce script contient un secret d\'enrôlement : ne le partagez pas et supprimez-le après usage.',
  'deployment.pkg.noToken': 'Aucun jeton actif',
  'deployment.pkg.noTokenDesc': 'Créez un jeton d\'enrôlement pour générer un paquet.',
  'deployment.pkg.unavailable': 'Aperçu indisponible',

  'deployment.rel.title': 'Versions de l\'agent',
  'deployment.rel.desc': 'Versions publiées et taux d\'adoption sur votre parc.',
  'deployment.rel.version': 'Version',
  'deployment.rel.publishedAt': 'Publiée le',
  'deployment.rel.adoption': 'Adoption',
  'deployment.rel.adoptionOf': 'Adoption de la version {version}',
  'deployment.rel.notes': 'Notes de version',
  'deployment.rel.latest': 'Dernière version',
  'deployment.rel.devices': 'Appareils sur ce canal',
  'deployment.rel.empty': 'Aucune version publiée',

  'deployment.prog.title': 'Progression par appareil',
  'deployment.prog.desc': 'Version d\'agent installée comparée à la dernière version du canal de chaque appareil.',
  'deployment.prog.overall': 'Progression globale',
  'deployment.prog.summary': 'Synthèse du déploiement',
  'deployment.prog.device': 'Appareil',
  'deployment.prog.installed': 'Installée',
  'deployment.prog.target': 'Cible',
  'deployment.prog.progress': 'Progression',
  'deployment.prog.progressOf': 'Progression de {name}',
  'deployment.prog.lastSeen': 'Dernière activité',
  'deployment.prog.state.updated': 'À jour',
  'deployment.prog.state.updating': 'En cours',
  'deployment.prog.state.waiting': 'En attente',
  'deployment.prog.ofTotal': 'sur {total} appareil(s)',
  'deployment.prog.waitingHint': 'Hors ligne : mise à jour à la reconnexion',
  'deployment.prog.filter': 'Filtrer par état',
  'deployment.prog.filter.all': 'Tous les états',
  'deployment.prog.empty': 'Aucun appareil à afficher',

  'deployment.wiz.open': 'Enrôler 100 machines',
  'deployment.wiz.title': 'Assistant d\'enrôlement de masse',
  'deployment.wiz.steps': 'Étapes de l\'assistant',
  'deployment.wiz.step.scope': 'Périmètre',
  'deployment.wiz.step.token': 'Jeton',
  'deployment.wiz.step.method': 'Méthode',
  'deployment.wiz.step.follow': 'Suivi',
  'deployment.wiz.scopeDesc': 'Combien de machines, dans quel groupe et sur quel canal de mise à jour ?',
  'deployment.wiz.count': 'Nombre de machines',
  'deployment.wiz.countInvalid': 'Entrez un nombre entre 1 et 100 000',
  'deployment.wiz.tokenDesc': 'Un jeton limité à {count} enrôlement(s) sera créé.',
  'deployment.wiz.defaultLabel': 'Enrôlement de {count} machines',
  'deployment.wiz.tokenReady': 'Jeton « {label} » créé ({count} usage(s) maximum).',
  'deployment.wiz.followDesc': 'Déployez le script avec votre outil (Intune, Jamf, GPO…). Les machines apparaissent dans le parc dès leur enrôlement.',
  'deployment.wiz.enrolled': 'Machines enrôlées',
  'deployment.wiz.openProgress': 'Voir la progression',
  'deployment.wiz.back': 'Précédent',
  'deployment.wiz.next': 'Suivant',
} as const;

export const deploymentEn: Record<keyof typeof deploymentFr, string> = {
  'deployment.pageTitle': 'Agent deployment',
  'deployment.pageDesc': 'Enroll machines in bulk, generate packages and track updates.',
  'deployment.tabs': 'Deployment sections',
  'deployment.tab.tokens': 'Enrollment tokens',
  'deployment.tab.packages': 'Packages and scripts',
  'deployment.tab.releases': 'Channels and versions',
  'deployment.tab.progress': 'Progress',
  'deployment.cancel': 'Cancel',
  'deployment.close': 'Close',
  'deployment.copy': 'Copy',
  'deployment.copied': 'Copied to clipboard',
  'deployment.copyFailed': 'Copy failed: select the text manually',
  'deployment.refresh': 'Refresh',
  'deployment.status': 'Status',
  'deployment.actions': 'Actions',
  'deployment.channel.stable': 'Stable',
  'deployment.channel.beta': 'Beta',
  'deployment.channel.stable.desc': 'Validated releases, recommended for production.',
  'deployment.channel.beta.desc': 'Early features, for a pilot group.',

  'deployment.token.title': 'Enrollment tokens',
  'deployment.token.desc': 'A token lets a machine join the organization with no local intervention.',
  'deployment.token.new': 'New token',
  'deployment.token.newDesc': 'Choose the target group, validity period and number of allowed enrollments.',
  'deployment.token.create': 'Create token',
  'deployment.token.createError': 'Could not create the token',
  'deployment.token.label': 'Token name',
  'deployment.token.labelPlaceholder': 'E.g. Intune rollout — HQ',
  'deployment.token.labelRequired': 'Name is required',
  'deployment.token.group': 'Target group',
  'deployment.token.noGroup': 'No group',
  'deployment.token.channel': 'Channel',
  'deployment.token.expiry': 'Validity',
  'deployment.token.days': '{count} days',
  'deployment.token.maxUses': 'Maximum uses',
  'deployment.token.unlimited': 'Unlimited',
  'deployment.token.maxUsesInvalid': 'Enter a whole number above 0, or leave empty',
  'deployment.token.expiresAt': 'Expires on',
  'deployment.token.usage': 'Usage',
  'deployment.token.usageOf': 'Usage of token {label}',
  'deployment.token.usesUnlimited': '{count} use(s), no limit',
  'deployment.token.createdBy': 'by {name}',
  'deployment.token.empty': 'No enrollment tokens',
  'deployment.token.emptyDesc': 'Create a token to enroll your first machines.',
  'deployment.token.status.active': 'Active',
  'deployment.token.status.revoked': 'Revoked',
  'deployment.token.status.expired': 'Expired',
  'deployment.token.status.exhausted': 'Exhausted',
  'deployment.token.copy': 'Copy token {label}',
  'deployment.token.generate': 'Generate a package with {label}',
  'deployment.token.revoke': 'Revoke {label}',
  'deployment.token.revokeTitle': 'Revoke this token?',
  'deployment.token.revokeDesc': 'Token "{label}" will no longer enroll machines. Machines already enrolled are not affected.',
  'deployment.token.revokeConfirm': 'Revoke',
  'deployment.token.revoked': 'Token revoked',
  'deployment.token.revokeError': 'Could not revoke the token',
  'deployment.token.createdTitle': 'Token created',
  'deployment.token.createdDesc': 'Copy the token now.',
  'deployment.token.secretOnce': 'This secret is shown only once. Store it in a secrets vault.',
  'deployment.token.goGenerate': 'Generate a package',

  'deployment.pkg.title': 'Package and script generator',
  'deployment.pkg.desc': 'The selected token is embedded in the generated script.',
  'deployment.pkg.token': 'Enrollment token',
  'deployment.pkg.version': 'Agent version',
  'deployment.pkg.secret': 'Token secret',
  'deployment.pkg.secretHint': 'The secret is only shown at creation. Paste it here to embed it in the script.',
  'deployment.pkg.secretInvalid': 'Invalid secret format',
  'deployment.pkg.kind': 'Deployment type',
  'deployment.pkg.kind.msi': 'MSI (Windows)',
  'deployment.pkg.kind.msi.desc': 'Silent install through msiexec',
  'deployment.pkg.kind.pkg': 'PKG (macOS)',
  'deployment.pkg.kind.pkg.desc': 'Package installer script',
  'deployment.pkg.kind.intune': 'Intune script',
  'deployment.pkg.kind.intune.desc': 'Idempotent PowerShell for Intune',
  'deployment.pkg.kind.jamf': 'Jamf script',
  'deployment.pkg.kind.jamf.desc': 'Jamf Pro script with parameters',
  'deployment.pkg.kind.shell': 'Shell command',
  'deployment.pkg.kind.shell.desc': 'One line for Linux and macOS',
  'deployment.pkg.silent': 'Silent install',
  'deployment.pkg.silentDesc': 'No window is shown to the user.',
  'deployment.pkg.preview': 'Script preview',
  'deployment.pkg.previewDesc': 'Generated in your browser; nothing is sent to Siraj.',
  'deployment.pkg.copyCommand': 'Copy command',
  'deployment.pkg.download': 'Download script',
  'deployment.pkg.downloaded': '{file} downloaded',
  'deployment.pkg.placeholderWarning': 'The token secret is unknown: the script contains a placeholder to replace before use.',
  'deployment.pkg.sensitive': 'This script contains an enrollment secret: do not share it and delete it after use.',
  'deployment.pkg.noToken': 'No active token',
  'deployment.pkg.noTokenDesc': 'Create an enrollment token to generate a package.',
  'deployment.pkg.unavailable': 'Preview unavailable',

  'deployment.rel.title': 'Agent versions',
  'deployment.rel.desc': 'Published versions and adoption rate across your fleet.',
  'deployment.rel.version': 'Version',
  'deployment.rel.publishedAt': 'Published on',
  'deployment.rel.adoption': 'Adoption',
  'deployment.rel.adoptionOf': 'Adoption of version {version}',
  'deployment.rel.notes': 'Release notes',
  'deployment.rel.latest': 'Latest version',
  'deployment.rel.devices': 'Devices on this channel',
  'deployment.rel.empty': 'No published versions',

  'deployment.prog.title': 'Progress by device',
  'deployment.prog.desc': 'Installed agent version compared to the latest version of each device\'s channel.',
  'deployment.prog.overall': 'Overall progress',
  'deployment.prog.summary': 'Deployment summary',
  'deployment.prog.device': 'Device',
  'deployment.prog.installed': 'Installed',
  'deployment.prog.target': 'Target',
  'deployment.prog.progress': 'Progress',
  'deployment.prog.progressOf': 'Progress of {name}',
  'deployment.prog.lastSeen': 'Last activity',
  'deployment.prog.state.updated': 'Up to date',
  'deployment.prog.state.updating': 'In progress',
  'deployment.prog.state.waiting': 'Waiting',
  'deployment.prog.ofTotal': 'out of {total} device(s)',
  'deployment.prog.waitingHint': 'Offline: updates on reconnection',
  'deployment.prog.filter': 'Filter by state',
  'deployment.prog.filter.all': 'All states',
  'deployment.prog.empty': 'No devices to display',

  'deployment.wiz.open': 'Enroll 100 machines',
  'deployment.wiz.title': 'Bulk enrollment wizard',
  'deployment.wiz.steps': 'Wizard steps',
  'deployment.wiz.step.scope': 'Scope',
  'deployment.wiz.step.token': 'Token',
  'deployment.wiz.step.method': 'Method',
  'deployment.wiz.step.follow': 'Tracking',
  'deployment.wiz.scopeDesc': 'How many machines, in which group and on which update channel?',
  'deployment.wiz.count': 'Number of machines',
  'deployment.wiz.countInvalid': 'Enter a number between 1 and 100,000',
  'deployment.wiz.tokenDesc': 'A token limited to {count} enrollment(s) will be created.',
  'deployment.wiz.defaultLabel': 'Enrollment of {count} machines',
  'deployment.wiz.tokenReady': 'Token "{label}" created ({count} use(s) maximum).',
  'deployment.wiz.followDesc': 'Deploy the script with your tool (Intune, Jamf, GPO…). Machines appear in the fleet as soon as they enroll.',
  'deployment.wiz.enrolled': 'Enrolled machines',
  'deployment.wiz.openProgress': 'View progress',
  'deployment.wiz.back': 'Back',
  'deployment.wiz.next': 'Next',
};

export const deploymentAr: Record<keyof typeof deploymentFr, string> = {
  'deployment.pageTitle': 'نشر الوكلاء',
  'deployment.pageDesc': 'سجّل الأجهزة دفعة واحدة، وأنشئ الحزم وتابع التحديثات.',
  'deployment.tabs': 'أقسام النشر',
  'deployment.tab.tokens': 'رموز التسجيل',
  'deployment.tab.packages': 'الحزم والنصوص',
  'deployment.tab.releases': 'القنوات والإصدارات',
  'deployment.tab.progress': 'التقدّم',
  'deployment.cancel': 'إلغاء',
  'deployment.close': 'إغلاق',
  'deployment.copy': 'نسخ',
  'deployment.copied': 'تم النسخ إلى الحافظة',
  'deployment.copyFailed': 'تعذّر النسخ: حدّد النص يدويًا',
  'deployment.refresh': 'تحديث',
  'deployment.status': 'الحالة',
  'deployment.actions': 'إجراءات',
  'deployment.channel.stable': 'مستقرة',
  'deployment.channel.beta': 'تجريبية',
  'deployment.channel.stable.desc': 'إصدارات معتمدة، موصى بها للإنتاج.',
  'deployment.channel.beta.desc': 'ميزات مبكرة لمجموعة تجريبية.',

  'deployment.token.title': 'رموز التسجيل',
  'deployment.token.desc': 'يتيح الرمز لجهاز الانضمام إلى المؤسسة دون أي تدخل محلي.',
  'deployment.token.new': 'رمز جديد',
  'deployment.token.newDesc': 'اختر المجموعة المستهدفة ومدة الصلاحية وعدد عمليات التسجيل المسموح بها.',
  'deployment.token.create': 'إنشاء الرمز',
  'deployment.token.createError': 'تعذّر إنشاء الرمز',
  'deployment.token.label': 'اسم الرمز',
  'deployment.token.labelPlaceholder': 'مثال: نشر Intune — المقر',
  'deployment.token.labelRequired': 'الاسم مطلوب',
  'deployment.token.group': 'المجموعة المستهدفة',
  'deployment.token.noGroup': 'بدون مجموعة',
  'deployment.token.channel': 'القناة',
  'deployment.token.expiry': 'الصلاحية',
  'deployment.token.days': '{count} يومًا',
  'deployment.token.maxUses': 'الحد الأقصى للاستخدام',
  'deployment.token.unlimited': 'غير محدود',
  'deployment.token.maxUsesInvalid': 'أدخل عددًا صحيحًا أكبر من 0 أو اتركه فارغًا',
  'deployment.token.expiresAt': 'ينتهي في',
  'deployment.token.usage': 'الاستخدام',
  'deployment.token.usageOf': 'استخدام الرمز {label}',
  'deployment.token.usesUnlimited': '{count} استخدام، بلا حد',
  'deployment.token.createdBy': 'بواسطة {name}',
  'deployment.token.empty': 'لا توجد رموز تسجيل',
  'deployment.token.emptyDesc': 'أنشئ رمزًا لتسجيل أولى أجهزتك.',
  'deployment.token.status.active': 'نشط',
  'deployment.token.status.revoked': 'ملغى',
  'deployment.token.status.expired': 'منتهي',
  'deployment.token.status.exhausted': 'مستنفد',
  'deployment.token.copy': 'نسخ الرمز {label}',
  'deployment.token.generate': 'إنشاء حزمة بالرمز {label}',
  'deployment.token.revoke': 'إلغاء {label}',
  'deployment.token.revokeTitle': 'إلغاء هذا الرمز؟',
  'deployment.token.revokeDesc': 'لن يتمكن الرمز «{label}» من تسجيل أجهزة جديدة. الأجهزة المسجّلة سابقًا لا تتأثر.',
  'deployment.token.revokeConfirm': 'إلغاء الرمز',
  'deployment.token.revoked': 'تم إلغاء الرمز',
  'deployment.token.revokeError': 'تعذّر إلغاء الرمز',
  'deployment.token.createdTitle': 'تم إنشاء الرمز',
  'deployment.token.createdDesc': 'انسخ الرمز الآن.',
  'deployment.token.secretOnce': 'يُعرض هذا السر مرة واحدة فقط. احفظه في مخزن أسرار.',
  'deployment.token.goGenerate': 'إنشاء حزمة',

  'deployment.pkg.title': 'منشئ الحزم والنصوص',
  'deployment.pkg.desc': 'يُدمج الرمز المختار في النص الناتج.',
  'deployment.pkg.token': 'رمز التسجيل',
  'deployment.pkg.version': 'إصدار الوكيل',
  'deployment.pkg.secret': 'سر الرمز',
  'deployment.pkg.secretHint': 'لا يُعرض السر إلا عند الإنشاء. الصقه هنا لدمجه في النص.',
  'deployment.pkg.secretInvalid': 'صيغة السر غير صالحة',
  'deployment.pkg.kind': 'نوع النشر',
  'deployment.pkg.kind.msi': 'MSI (ويندوز)',
  'deployment.pkg.kind.msi.desc': 'تثبيت صامت عبر msiexec',
  'deployment.pkg.kind.pkg': 'PKG (ماك)',
  'deployment.pkg.kind.pkg.desc': 'نص تثبيت الحزمة',
  'deployment.pkg.kind.intune': 'نص Intune',
  'deployment.pkg.kind.intune.desc': 'PowerShell قابل للتكرار لـ Intune',
  'deployment.pkg.kind.jamf': 'نص Jamf',
  'deployment.pkg.kind.jamf.desc': 'نص Jamf Pro مع معاملات',
  'deployment.pkg.kind.shell': 'أمر shell',
  'deployment.pkg.kind.shell.desc': 'سطر واحد للينكس وماك',
  'deployment.pkg.silent': 'تثبيت صامت',
  'deployment.pkg.silentDesc': 'لا تظهر أي نافذة للمستخدم.',
  'deployment.pkg.preview': 'معاينة النص',
  'deployment.pkg.previewDesc': 'يُنشأ في متصفحك؛ لا يُرسل شيء إلى سراج.',
  'deployment.pkg.copyCommand': 'نسخ الأمر',
  'deployment.pkg.download': 'تنزيل النص',
  'deployment.pkg.downloaded': 'تم تنزيل {file}',
  'deployment.pkg.placeholderWarning': 'سر الرمز غير معروف: يحتوي النص على عنصر نائب يجب استبداله قبل الاستخدام.',
  'deployment.pkg.sensitive': 'يحتوي هذا النص على سر تسجيل: لا تشاركه واحذفه بعد الاستخدام.',
  'deployment.pkg.noToken': 'لا يوجد رمز نشط',
  'deployment.pkg.noTokenDesc': 'أنشئ رمز تسجيل لإنشاء حزمة.',
  'deployment.pkg.unavailable': 'المعاينة غير متاحة',

  'deployment.rel.title': 'إصدارات الوكيل',
  'deployment.rel.desc': 'الإصدارات المنشورة ونسبة اعتمادها في أجهزتك.',
  'deployment.rel.version': 'الإصدار',
  'deployment.rel.publishedAt': 'تاريخ النشر',
  'deployment.rel.adoption': 'نسبة الاعتماد',
  'deployment.rel.adoptionOf': 'اعتماد الإصدار {version}',
  'deployment.rel.notes': 'ملاحظات الإصدار',
  'deployment.rel.latest': 'أحدث إصدار',
  'deployment.rel.devices': 'الأجهزة على هذه القناة',
  'deployment.rel.empty': 'لا توجد إصدارات منشورة',

  'deployment.prog.title': 'التقدّم حسب الجهاز',
  'deployment.prog.desc': 'إصدار الوكيل المثبّت مقارنة بأحدث إصدار في قناة كل جهاز.',
  'deployment.prog.overall': 'التقدّم الإجمالي',
  'deployment.prog.summary': 'ملخّص النشر',
  'deployment.prog.device': 'الجهاز',
  'deployment.prog.installed': 'المثبّت',
  'deployment.prog.target': 'المستهدف',
  'deployment.prog.progress': 'التقدّم',
  'deployment.prog.progressOf': 'تقدّم {name}',
  'deployment.prog.lastSeen': 'آخر نشاط',
  'deployment.prog.state.updated': 'محدَّث',
  'deployment.prog.state.updating': 'قيد التنفيذ',
  'deployment.prog.state.waiting': 'في الانتظار',
  'deployment.prog.ofTotal': 'من أصل {total} جهاز',
  'deployment.prog.waitingHint': 'غير متصل: يُحدَّث عند إعادة الاتصال',
  'deployment.prog.filter': 'تصفية حسب الحالة',
  'deployment.prog.filter.all': 'كل الحالات',
  'deployment.prog.empty': 'لا توجد أجهزة للعرض',

  'deployment.wiz.open': 'تسجيل 100 جهاز',
  'deployment.wiz.title': 'معالج التسجيل الجماعي',
  'deployment.wiz.steps': 'خطوات المعالج',
  'deployment.wiz.step.scope': 'النطاق',
  'deployment.wiz.step.token': 'الرمز',
  'deployment.wiz.step.method': 'الطريقة',
  'deployment.wiz.step.follow': 'المتابعة',
  'deployment.wiz.scopeDesc': 'كم عدد الأجهزة، وفي أي مجموعة، وعلى أي قناة تحديث؟',
  'deployment.wiz.count': 'عدد الأجهزة',
  'deployment.wiz.countInvalid': 'أدخل رقمًا بين 1 و100000',
  'deployment.wiz.tokenDesc': 'سيُنشأ رمز محدود بـ {count} عملية تسجيل.',
  'deployment.wiz.defaultLabel': 'تسجيل {count} جهاز',
  'deployment.wiz.tokenReady': 'تم إنشاء الرمز «{label}» (حد أقصى {count} استخدام).',
  'deployment.wiz.followDesc': 'انشر النص بأداتك (Intune أو Jamf أو GPO…). تظهر الأجهزة في القائمة فور تسجيلها.',
  'deployment.wiz.enrolled': 'الأجهزة المسجّلة',
  'deployment.wiz.openProgress': 'عرض التقدّم',
  'deployment.wiz.back': 'السابق',
  'deployment.wiz.next': 'التالي',
};
